
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton, AppDateTimePicker } from '@/components';
import { useVersionAdd } from '@/modules/version/model/add';
import { VersionOptions } from '@/modules/version/model/mixins';
import { ROUTE_NAME_VERSION } from '@/modules/version/router';

export default defineComponent({
    name: ROUTE_NAME_VERSION.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton, AppDateTimePicker },
    setup() {
        const { model, v$, create } = useVersionAdd();

        return { v$, model, VersionOptions, create };
    }
});
